import { setTitle } from '../../../lib';
import { IAPIGameItem } from '../../../model/api-modules';

export const setGamePageTitle = (
  gameList: ReadonlyArray<IAPIGameItem>,
  gameID: string
) => {
  const gameItem = gameList.find((item) => item.gameID === gameID);
  if (gameItem) {
    setTitle(gameItem.gameName);
  }
};

export const getCurrentStudioGameList = (
  gameList: ReadonlyArray<IAPIGameItem>,
  studioID?: string
) => {
  if (!studioID) {
    return [];
  }
  return gameList.filter((item) => {
    if (studioID === item.studioID && item.gameName) {
      return true;
    }
    return false;
  });
};
